import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = ({ loading = true }) => {
  if (!loading) return null;

  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="spinner"></div>
        <p>Please wait, we are getting your houses ready...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
